import * as types from './mutation-types'
import Vue from 'vue'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

export default {
    [types.SET_EMAIL_ITEM] (state, data) {
        state.send_mail_item = data
    },
    [types.CHANGEDRAWER] (state, data) {
            state.changedrawer = data
    },
    [types.SET_MENU] (state, data) {
            state.menu = data
    },
    [types.SET_GROUP_BRANCH] (state, data) {
            state.groupBranch = data
    },
    [types.SET_GROUP_SERVICE] (state, data) {
            state.groupService = data
    },
    [types.SET_SFTP_PAYLOAD] (state, data) {
            state.sftpConfirmPayload = data
    },
    [types.SET_SFTP_PAGE] (state, data) {
            state.sftpConfirmPage = data
    },
    [types.SET_SFTP_SELECT] (state, data) {
            state.sftpConfirmSelect = data
    },
    [types.AUTH_PORTAL_CHECK] (state, data) {
            state.refreshtoken = data
            state.accesstoken = ''
            state.authen = false
            state.profile = state.profile
            state.centresso = false
            state.status = 'processing'
    },
    [types.AUTH_PORTAL_SUCCESS] (state, data) {
            state.refreshtoken =  state.refreshtoken
            state.accesstoken = data.accesstoken
            state.authen = true
            state.profile = state.profile
            state.centresso = false
            state.status = 'finish'
    },
    [types.AUTH_PORTAL_EXPIRED] (state) {
            state.refreshtoken = ''
            state.accesstoken = ''
            state.authen = false
            state.profile = {},
            state.centresso = false
            state.status = 'finish'
    },

    [types.ACCOUNT_PORTAL_CHECK] (state, data) {
            state.refreshtoken = state.refreshtoken
            state.accesstoken =  state.accesstoken
            state.authen = state.authen
            state.profile = state.profile
            state.centresso = false
            state.status = 'processing'

    },

    [types.ACCOUNT_PORTAL_SUCCESS] (state, data) {
            var currentuser = data['business_owner'].find(d => (d.username).toLowerCase() === (Vue.$cookies.get('Username')).toLowerCase())
            data['currentuser'] = currentuser
            state.refreshtoken = state.refreshtoken
            state.accesstoken =  state.accesstoken
            state.authen = state.authen
            state.profile = data
            state.centresso = false
            state.status = 'finish'

    },

    [types.ACCOUNT_PORTAL_NOTFOUND] (state, data) {
            state.refreshtoken = ''
            state.accesstoken = ''
            state.authen = false
            state.profile = {}
            state.centresso = false
            state.status = 'finish'
    },

//     [types.ACCOUNTPAYMENT_PORTAL_REQUEST] (state, data) {
//         state.refreshtoken = state.refreshtoken
//         state.accesstoken =  state.accesstoken
//         state.authen = state.authen
//         state.profile = state.profile
//         state.centresso = false
//         state.authenpayment = data

//      },

//      [types.ACCOUNTPAYMENT_PORTAL_SUCCESS] (state, data) {
//         state.refreshtoken = state.refreshtoken
//         state.accesstoken =  state.accesstoken
//         state.authen = state.authen
//         state.profile = state.profile
//         state.centresso = false
//         state.authenpayment = true
//         state.refreshtoken_payment = data
//      },
//      [types.ACCOUNTPAYMENT_PORTAL_CHECK] (state, data) {
//         state.refreshtoken = state.refreshtoken
//         state.accesstoken =  state.accesstoken
//         state.authen = state.authen
//         state.profile = state.profile
//         state.centresso = false
//         state.authenpayment = false
//         state.refreshtoken_payment = state.refreshtoken_payment
//      },
//      [types.ACCOUNTPAYMENT_PORTAL_NOTFOUND] (state) {
//             state.refreshtoken = ''
//             state.accesstoken = ''
//             state.authen = 'expired'
//             state.profile = {},
//             state.centresso = false
//             state.authenpayment = false
//             state.refreshtoken_payment = ''
//     },

}



// WEBPACK FOOTER //
// ./src/store/mutations.js